import { gql } from "@apollo/client";

export const campusQuery = gql`
  query campus($scenarioId: ID!, $filter: CampusFilterInput) {
    data(scenarioId: $scenarioId) {
      campuses(filter: $filter) {
        items {
          id
          code
          name
        }
        pageInfo {
          size
          page
          total
          hasNextPage
          hasPreviousPage
        }
      }
    }
  }
`;
